import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';

import { formatPlayer } from '../../lib/format';
import { pathTo } from '../../App/routes';

const PlayersLineup = ({ players, style }) => {
  if (!players) return '';

  return (
    <div className="players-lineup" style={style}>
      {players
        .map(
          player =>
            player && (
              <span key={player.jersey} className="nowrap">
                <Link
                  className="players-lineup--link"
                  to={pathTo('player', player.id)}
                  disabled={!player.id}
                >
                  {formatPlayer(player)}
                </Link>
              </span>
            ),
        )
        .reduce((prev, curr) => [prev, ' - ', curr])}
    </div>
  );
};
PlayersLineup.propTypes = {
  players: PropTypes.array.isRequired,
  style: PropTypes.object,
};

export default PlayersLineup;
